function validateDatePast18(value) {
  var todayDate = new Date();
  //todayDate.setHours(0).setMinutes(0).setSeconds(0).setMilliseconds(0);
  var lastAcceptedDate = new Date(
    todayDate.getFullYear() - 1,
    todayDate.getMonth() - 6,
    todayDate.getDate()
  );
  var inputDateParts = value.split("."),
    inputDate;
  inputDate = new Date(
    inputDateParts[2],
    parseInt(inputDateParts[1], 10) - 1,
    inputDateParts[0]
  );

  if (value === "" || inputDate.getTime() >= lastAcceptedDate.getTime()) {
    return true;
  }
  return false;
}

function validateDatePast(value) {
  var todayDate = new Date();
  //todayDate.setHours(0).setMinutes(0).setSeconds(0).setMilliseconds(0);
  var inputDateParts = value.split("."),
    inputDate;
  inputDate = new Date(
    inputDateParts[2],
    parseInt(inputDateParts[1], 10) - 1,
    inputDateParts[0]
  );
  if (value === "" || inputDate.getTime() > todayDate.getTime()) {
    return true;
  }
  return false;
}

function isWeekend(value) {
  var distance = $('select[name="wettkampfdistanz"]').val();
  var allowedDays = [];
  if (distance === "5k" || distance === "10k") {
    allowedDays = [0, 4, 5, 6];
  } else if (distance === "21k") {
    allowedDays = [0, 5, 6];
  } else {
    allowedDays = [0, 6];
  }
  var inputDateParts = value.split("."),
    inputDate;
  inputDate = new Date(
    inputDateParts[2],
    parseInt(inputDateParts[1], 10) - 1,
    inputDateParts[0]
  );

  if (allowedDays.includes(inputDate.getDay())) {
    return true;
  } else {
    return false;
  }
}

function isMonday(value) {
  var inputDateParts = value.split("."),
    inputDate;
  inputDate = new Date(
    inputDateParts[2],
    parseInt(inputDateParts[1], 10) - 1,
    inputDateParts[0]
  );

  if (inputDate.getDay() === 1) {
    return true;
  } else {
    return false;
  }
}

function validateDateFuture(value) {
  var todayDate = new Date();
  var inputDateParts = value.split("."),
    inputDate;
  inputDate = new Date(
    inputDateParts[2],
    parseInt(inputDateParts[1], 10) - 1,
    inputDateParts[0]
  );
  if (value === "" || inputDate.getTime() < todayDate.getTime()) {
    return true;
  }
  return false;
}

function validateHf(value) {
  if (
    value.match(/^(([1][2-9][0-9])|([2][0-1][0-9]|220))$/gi) ||
    value === ""
  ) {
    return true;
  }
  return false;
}

function validateDistance100(value) {
  if (
    value.match(
      /^(([0],[5-9])|([1-9][0-9]{0,1}|100)|([1-9][0-9]{0,1},[0-9]))$/gi
    ) ||
    value === ""
  ) {
    return true;
  }
  return false;
}

function validateDistance(value) {
  if (
    value.match(
      /^(([0],[5-9])|([1-9][0-9]{0,1}|100)|([1-9][0-9]{0,1},[0-9]|100,[0-5]))$/gi
    ) ||
    value === ""
  ) {
    return true;
  }
  return false;
}

function validateWeight(value) {
  if (
    value.match(
      /^(?:[3-9][0-9]|(?:[3-9][0-9],[0-9])|(?:[1][0-5][0-9])|(?:[1][0-5][0-9],[0-9])|160)$/gi
    ) ||
    value === ""
  ) {
    return true;
  }
  return false;
}

function validateSize(value) {
  if (value.match(/^[0-9],[0-9]{2}$/gi) || value === "") {
    return true;
  }
  return false;
}

function validateAge(value) {
  if (value.match(/^((?:[1-9][0-9])|100)$/gi) || value === "") {
    return true;
  }
  return false;
}

function validateDate(value) {
  if (value.match(/^[0-9]{2}.[0-9]{2}.[0-9]{4}$/gi) || value === "") {
    return true;
  }
  return false;
}

function validateTime(value) {
  if (value.match(/^[0-9]{1}:[0-9]{2}:[0-9]{2}$/gi) || value === "") {
    return true;
  }
  return false;
}

function validateLength(value) {
  if (value.match(/^[0-9]{1,},[0-9]{1,}$/gi) || value === "") {
    return true;
  }
  return false;
}

function validateLengthBorder(value) {
  value = value.replace(/,/g, ".");
  if (value <= 8 && value >= 4) {
    return true;
  }
  return false;
}

function validateTrainingPlan() {
  var $triningStart = $("#trainingsplanbeginn"),
    $competition = $("#wettkampfdatum"),
    inputCompetitionParts = $competition[0].value.split("."),
    inputTrainingStartParts = $triningStart[0].value.split("."),
    inputCompetition = new Date(
      inputCompetitionParts[2],
      parseInt(inputCompetitionParts[1], 10) - 1,
      inputCompetitionParts[0]
    ),
    inputTrainingStart = new Date(
      inputTrainingStartParts[2],
      parseInt(inputTrainingStartParts[1], 10) - 1,
      inputTrainingStartParts[0]
    ),
    minDate = new Date(
      inputTrainingStart.getFullYear(),
      inputTrainingStart.getMonth(),
      inputTrainingStart.getDate()
    ),
    maxDate = new Date(
      inputTrainingStart.getFullYear(),
      inputTrainingStart.getMonth(),
      inputTrainingStart.getDate()
    );

  minDate.setDate(minDate.getDate() + 56);
  maxDate.setDate(maxDate.getDate() + 112);

  if (
    inputCompetition.getTime() >= minDate.getTime() &&
    inputCompetition.getTime() <= maxDate.getTime()
  ) {
    return true;
  }
  return false;
}

function addPristineCustomValidators() {
  Pristine.addValidator(
    "custom-date",
    function (value) {
      return validateDate(value);
    },
    "Datum bitte wie folgt eingeben: tt.mm.jjjj.",
    5,
    true
  );

  Pristine.addValidator(
    "custom-date-future",
    function (value) {
      return validateDateFuture(value);
    },
    "Eingabefehler: Datum liegt in der Zukunft",
    5,
    true
  );

  Pristine.addValidator(
    "custom-date-past-18",
    function (value) {
      return validateDatePast18(value);
    },
    "Eingabefehler: Datum liegt mehr als 18 Monate zurück",
    5,
    true
  );

  Pristine.addValidator(
    "custom-time-running",
    function (value) {
      return validateTime(value);
    },
    "Laufzeit bitte wie folgt eingeben: h:mm:ss.",
    5,
    true
  );

  Pristine.addValidator(
    "custom-date-past",
    function (value) {
      return validateDatePast(value);
    },
    "Eingabefehler: Datum liegt in der Vergangenheit",
    5,
    true
  );

  Pristine.addValidator(
    "weekend",
    function (value) {
      return isWeekend(value);
    },
    "Die Kombination aus Wettkampftag und Distanz ist nicht möglich.",
    5,
    true
  );

  Pristine.addValidator(
    "training-plan",
    function (value) {
      return validateTrainingPlan(value);
    },
    "Überprüfe deine Daten. Zwischen Start und Ende des Traininigsplans müssen mindestens acht und maximal 16 Wochen liegen. Wenn du bereits früher ins Training einsteigen möchtest, suche dir vorerst ein Zwischenziel oder lasse dir von einem Laufcampus Trainer einen individuellen Trainingsplan schreiben.",
    5,
    true
  );
}
